import HomeNavbar from "./HomeNavbar"
import { motion, AnimatePresence } from "framer-motion";
import CompanyLogo from "../../../assets/images/un_resume_logo2.png";
import { MapPinIcon, ClockIcon, CalendarIcon, TagIcon, SearchIcon } from 'lucide-react'

export default function Volunteer() {

    // const filteredJobs = useMemo(() => {
    //     return jobs.filter(job => {
    //         const matchesSearch =
    //             job.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             job.companyName.toLowerCase().includes(searchQuery.toLowerCase());

    //         const matchesFilters =
    //             (!filters.location || job.location.toLowerCase().includes(filters.location.toLowerCase())) &&
    //             (!filters.minSalary || parseInt(job.salary) >= parseInt(filters.minSalary)) &&
    //             (!filters.jobType || job.type === filters.jobType);

    //         return matchesSearch && matchesFilters;
    //     });
    // }, [jobs, searchQuery, filters]);

    return (
        <>
            <HomeNavbar />
            <div className="mt-16 p-6 bg-gray-50 dark:bg-gray-900">
                {/* Header */}
                <div className="p-4 mt-6 mb-8">
                    <h1 className="text-4xl text-gray-800 dark:text-gray-100 font-semibold mb-6">Volunteer Opportunities</h1>
                    <p className="text-gray-600 dark:text-gray-400 mb-8 font-extralight">
                        Find meaningful volunteer positions with small and medium-sized enterprises. Help local businesses grow <br /> while gaining valuable experience and making a difference in your community.
                    </p>
                </div>

                {/* Search box */}
                <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm mb-8">
                    <div className="flex flex-col md:flex-row md:items-center gap-4 mb-6">
                        <div className="relative flex-grow">
                            <SearchIcon className="absolute left-3 top-3 h-5 w-5 text-gray-400 dark:text-gray-500" />
                            <input
                                type="text"
                                placeholder="Search for volunteer opportunities..."
                                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div className="flex gap-2">
                            <button className="px-4 py-2 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors">
                                Search
                            </button>
                            <button className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-full hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                                Clear
                            </button>
                        </div>
                    </div>
                    <div className="flex flex-wrap gap-4">
                        <div className="w-full sm:w-auto">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Location
                            </label>
                            <div className="relative">
                                <MapPinIcon className="absolute left-3 top-2 h-5 w-5 text-gray-400 dark:text-gray-500" />
                                <select className="w-full pl-10 pr-8 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-full appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500">
                                    <option value="">Any Location</option>
                                    <option value="remote">Remote</option>
                                    <option value="london">London</option>
                                    <option value="manchester">Manchester</option>
                                    <option value="birmingham">Birmingham</option>
                                    <option value="edinburgh">Edinburgh</option>
                                </select>
                            </div>
                        </div>
                        <div className="w-full sm:w-auto">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Time Commitment
                            </label>
                            <div className="relative">
                                <ClockIcon className="absolute left-3 top-2 h-5 w-5 text-gray-400 dark:text-gray-500" />
                                <select className="w-full pl-10 pr-8 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-full appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500">
                                    <option value="">Any Time</option>
                                    <option value="one-time">One-time</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="flexible">Flexible</option>
                                </select>
                            </div>
                        </div>
                        <div className="w-full sm:w-auto">
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                                Category
                            </label>
                            <div className="relative">
                                <TagIcon className="absolute left-3 top-2 h-5 w-5 text-gray-400 dark:text-gray-500" />
                                <select className="w-full pl-10 pr-8 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-full appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500">
                                    <option value="">All Categories</option>
                                    <option value="marketing">Marketing</option>
                                    <option value="tech">Technology</option>
                                    <option value="design">Design</option>
                                    <option value="finance">Finance</option>
                                    <option value="operations">Operations</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Volunteer Job Cards */}
                <div
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden border border-gray-100 dark:border-gray-700 hover:shadow-md transition-shadow duration-200">
                        <div
                            className="h-3"
                            style={{
                                backgroundColor: "pink",
                            }}
                        ></div>
                        <motion.div
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            className="p-6">
                            <div className="flex items-start justify-between mb-3">
                                <div>
                                    <h3 className="font-bold text-lg text-gray-800 dark:text-gray-100 mb-1">
                                        title
                                    </h3>
                                    <p className="text-gray-600 dark:text-gray-400 font-medium">company</p>
                                </div>
                                <img
                                    src={CompanyLogo}
                                    alt={'Company logo'}
                                    className="w-12 h-12 object-contain rounded"
                                />
                            </div>
                            <div className="space-y-2 mb-4">
                                <div className="flex items-center text-gray-500 dark:text-gray-400">
                                    <MapPinIcon className="h-4 w-4 mr-2" />
                                    <span className="text-sm">location</span>
                                </div>
                                <div className="flex items-center text-gray-500 dark:text-gray-400">
                                    <ClockIcon className="h-4 w-4 mr-2" />
                                    <span className="text-sm">commitment</span>
                                </div>
                                <div className="flex items-center text-gray-500 dark:text-gray-400">
                                    <CalendarIcon className="h-4 w-4 mr-2" />
                                    <span className="text-sm">Posted a week ago</span>
                                </div>
                            </div>
                            <p className="text-gray-600 dark:text-gray-400 mb-4 line-clamp-3">description</p>
                            <div className="mb-4">
                                <div className="flex flex-wrap gap-2">
                                    <span
                                        className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded text-xs font-medium"
                                    >
                                        skill
                                    </span>
                                    <span className="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 rounded text-xs font-medium">
                                        +2 more
                                    </span>
                                </div>
                            </div>
                            <div className="flex justify-between items-center">
                                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium">
                                    Apply Now
                                </button>
                                <button className="px-4 py-2 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-md transition-colors text-sm font-medium">
                                    Learn More
                                </button>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </>
    )
}